export { EditClient } from './EditClient.main';
